import { twMerge } from "tailwind-merge";
import {
  Button,
  Card,
  CardContent,
  CardHeader,
  H5,
} from "@sellar-io/components";
import { ReactElement, useState } from "react";
import { Icon, SpinnerLegacy } from "../../../../components";
import { useSupplierPaymentInformation } from "../../../../hooks/api/v2/supplierPaymentInformation/useSupplierPaymentInformation";
import { useSellarCurrentBusiness } from "../../../../hooks/useSellarCurrentBusiness.shared";
import { CreateBankDetailsDialog } from "./CreateBankDetailsDialog";
import { UpdateBankDetailsDialog } from "./UpdateBankDetailsDialog";

export const BusinessBankSettingsCard = ({
  supplierId,
}: {
  supplierId: number;
}): ReactElement => {
  const { business } = useSellarCurrentBusiness();
  const supplierPaymentInformationQuery = useSupplierPaymentInformation(
    supplierId,
    business?.Supplier?.SupplierPaymentInformationId,
    {
      enabled: !!business?.Supplier?.SupplierPaymentInformationId,
    },
  );

  const [createModalActive, setCreateModalActive] = useState(false);
  const [updateModalActive, setUpdateModalActive] = useState(false);

  return (
    <Card className="bg-white">
      <CardHeader className={twMerge("bg-white", "p-4")}>
        <div className="flex items-center justify-between">
          <div className="flex flex-col">
            <H5>Banking info</H5>
            <div className="text-sm text-gray-500">
              Displays on all invoices available to your customers
            </div>
          </div>
          <Button
            onClick={() => {
              if (business?.Supplier?.SupplierPaymentInformationId) {
                return setUpdateModalActive(true);
              }
              return setCreateModalActive(true);
            }}
          >
            <Icon size={0.7} icon={"PENCIL"} />
            Edit
          </Button>
        </div>
      </CardHeader>
      <CardContent className={"p-4"}>
        {supplierPaymentInformationQuery.isLoading &&
        supplierPaymentInformationQuery.fetchStatus !== "idle" ? (
          <SpinnerLegacy />
        ) : (
          <>
            {supplierPaymentInformationQuery.data ? (
              <div className={"flex items-center justify-between"}>
                <div className="flex flex-col">
                  <H5>Account number</H5>
                  <p>
                    {supplierPaymentInformationQuery.data.bankAccountNumber}
                  </p>
                </div>
                <div className="flex flex-col">
                  <H5>Sort code</H5>
                  <p>{supplierPaymentInformationQuery.data.bankSortCode}</p>
                </div>
              </div>
            ) : (
              <p>No payment information provided</p>
            )}
          </>
        )}
      </CardContent>
      {business?.Supplier?.SupplierPaymentInformationId && (
        <UpdateBankDetailsDialog
          active={updateModalActive}
          onDismiss={() => setUpdateModalActive(false)}
          supplierPaymentInformationId={
            business.Supplier.SupplierPaymentInformationId
          }
          supplierId={supplierId}
        />
      )}
      <CreateBankDetailsDialog
        active={createModalActive}
        onDismiss={() => setCreateModalActive(false)}
        supplierId={supplierId}
      />
    </Card>
  );
};
